module.exports = __webpack_public_path__ + "img/question-screenshot.4a7f1b15.png";